module.exports = __webpack_public_path__ + "static/img/fm04.269e365.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fm_bg/fm04.jpg
// module id = QeX9
// module chunks = 46